// API URL

// AUTH
export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_SIGNIN = 'AUTH_SIGNIN';

// ALERT
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';

// COMPANY
export const ADD_COMPANY = 'ADD_COMPANY';
export const GET_COMPANIES = 'GET_COMPANIES';
export const GET_COMPANY = 'GET_COMPANY';
export const UPDATE_COMPANY = 'UPDATE_COMPANY';
export const DELETE_COMPANY = 'DELETE_COMPANY';
export const GET_COMPANY_DETAILS_GST = 'GET_COMPANY_DETAILS_GST';
export const GET_COMPANY_DETAILS = 'GET_COMPANY_DETAILS';
export const UPDATE_COMPANY_SETTING = 'UPDATE_COMPANY_SETTING';
export const GET_BUSINESS_TYPES = 'GET_BUSINESS_TYPES';
export const SHARED_COMPANY = 'SHARED_COMPANY';
export const GET_WP_QR_CODE = 'GET_WP_QR_CODE';
export const GET_WP_MESSAGE = 'GET_WP_MESSAGE';
export const GET_WP_MESSAGE_PDF = 'GET_WP_MESSAGE_PDF';
export const UPDATE_DYNAMIC_BARCODE = 'UPDATE_DYNAMIC_BARCODE';
export const GET_MOBILE_BY_EMAIL = 'GET_MOBILE_BY_EMAIL';

// COUNTRY
export const ADD_COUNTRY = 'ADD_COUNTRY';
export const GET_COUNTRIES = 'GET_COUNTRIES';
export const GET_COUNTRY = 'GET_COUNTRY';
export const UPDATE_COUNTRY = 'UPDATE_COUNTRY';
export const DELETE_COUNTRY = 'DELETE_COUNTRY';

// STATE
export const ADD_STATE = 'ADD_STATE';
export const GET_STATES = 'GET_STATES';
export const GET_STATE = 'GET_STATE';
export const UPDATE_STATE = 'UPDATE_STATE';
export const DELETE_STATE = 'DELETE_STATE';

// CITY
export const ADD_CITY = 'ADD_CITY';
export const GET_CITIES = 'GET_CITIES';
export const GET_CITY = 'GET_CITY';
export const UPDATE_CITY = 'UPDATE_CITY';
export const DELETE_CITY = 'DELETE_CITY';

// CUSTOMER
export const ADD_CUSTOMER = 'ADD_CUSTOMER';
export const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER';
export const GET_CUSTOMER = 'GET_CUSTOMER';
export const CUSTOMER_ERROR = 'CUSTOMER_ERROR';
export const GET_ONE_CUSTOMER = 'GET_ONE_CUSTOMER';

// VENDOR
export const ADD_VENDOR = 'ADD_VENDOR';
export const UPDATE_VENDOR = 'UPDATE_VENDOR';
export const GET_VENDOR = 'GET_VENDOR';
export const GET_VENDORS = 'GET_VENDORS';
export const DELETE_VENDOR = 'DELETE_VENDOR';
export const GET_ONE_VENDORS = 'GET_ONE_VENDORS';

// ACCOUNT
export const ADD_ACCOUNT = 'ADD_ACCOUNT';
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
export const GET_ACCOUNT = 'GET_ACCOUNT';
export const GET_ACCOUNTS = 'GET_ACCOUNTS';
export const GET_ACCOUNTS_FOR_CASH_BANK = 'GET_ACCOUNTS_FOR_CASH_BANK';
export const GET_ACCOUNTS_FOR_DASHBOARD = 'GET_ACCOUNTS_FOR_DASHBOARD';
export const GET_ACCOUNTS_FOR_MASTER = 'GET_ACCOUNTS_FOR_MASTER';
export const GET_SUSPENSE_ACCOUNTS = 'GET_SUSPENSE_ACCOUNTS';
export const ACCOUNT_ERROR = 'ACCOUNT_ERROR';
export const DELETE_ACCOUNT = 'DELETE_ACCOUNT';
export const MULTI_DELETE_ACCOUNT = 'MULTI_DELETE_ACCOUNT';
export const EMPTY_ACCOUNT = 'EMPTY_ACCOUNT';
export const GET_ACCOUNT_BROKER = 'GET_ACCOUNT_BROKER';

// ITEM
export const ADD_ITEM = 'ADD_ITEM';
export const UPDATE_ITEM = 'UPDATE_ITEM';
export const GET_ITEM = 'GET_ITEM';
export const GET_ITEM_FOR_MASTER = 'GET_ITEM_FOR_MASTER';
export const GET_ITEM_GROUP = 'GET_ITEM_GROUP';
export const ITEM_ERROR = 'ITEM_ERROR';
export const DELETE_ITEM = 'DELETE_ITEM';
export const GET_ITEM_BY_FINISH_ITEM = 'GET_ITEM_BY_FINISH_ITEM';
export const GET_ONE_ITEM = 'GET_ONE_ITEM';
export const GET_ITEMS = 'GET_ITEMS';

//JournalVoucher
export const GET_JOURNAL_VOUCHER = 'GET_JOURNAL_VOUCHER';
export const ADD_JOURNAL_VOUCHER = 'ADD_JOURNAL_VOUCHER';
export const UPDATE_JOURNAL_VOUCHER = 'UPDATE_JOURNAL_VOUCHER';
export const DELETE_JOURNAL_VOUCHER = 'DELETE_JOURNAL_VOUCHER';
export const CHECK_LAST_DOC_NUMBER_VOUCHER = 'CHECK_LAST_DOC_NUMBER_VOUCHER';

// export const UPDATE_USER = 'UPDATE_USER';
// export const DELETE_USER = 'DELETE_USER';

// WAREHOUSE
export const ADD_WAREHOUSE = 'ADD_WAREHOUSE';
export const UPDATE_WAREHOUSE = 'UPDATE_WAREHOUSE';
export const GET_WAREHOUSE = 'GET_WAREHOUSE';
export const DELETE_WAREHOUSE = 'DELETE_WAREHOUSE';
export const MULTI_DELETE_WAREHOUSE = 'MULTI_DELETE_WAREHOUSE';
export const GET_ONE_WAREHOUSES = 'GET_ONE_WAREHOUSES';

// CATEGORY
export const ADD_CATEGORY = 'ADD_CATEGORY';
export const UPDATE_CATEGORY = 'UPDATE_CATEGORY';
export const GET_CATEGORY = 'GET_CATEGORY';
export const DELETE_CATEGORY = 'DELETE_CATEGORY';
export const GET_ONE_CATEGORY = 'GET_ONE_CATEGORY';
export const MULTI_DELETE_CATEGORY = 'MULTI_DELETE_CATEGORY';

// BRAND
export const ADD_BRAND = 'ADD_BRAND';
export const UPDATE_BRAND = 'UPDATE_BRAND';
export const GET_BRAND = 'GET_BRAND';
export const DELETE_BRAND = 'DELETE_BRAND';
export const GET_ONE_BRAND = 'c';

// SERIES
export const ADD_SERIES = 'ADD_SERIES';
export const UPDATE_SERIES = 'UPDATE_SERIES';
export const GET_SERIES = 'GET_SERIES';
export const DELETE_SERIES = 'DELETE_SERIES';
export const GET_ONE_SERIES = 'GET_ONE_SERIES';
export const MULTI_DELETE_SERIES = 'MULTI_DELETE_SERIES';

// MODEL
export const ADD_MODEL = 'ADD_MODEL';
export const UPDATE_MODEL = 'UPDATE_MODEL';
export const GET_MODEL = 'GET_MODEL';
export const DELETE_MODEL = 'DELETE_MODEL';
export const GET_ONE_MODEL = 'GET_ONE_MODEL';

// COLOR
export const ADD_COLOR = 'ADD_COLOR';
export const UPDATE_COLOR = 'UPDATE_COLOR';
export const GET_COLOR = 'GET_COLOR';
export const DELETE_COLOR = 'DELETE_COLOR';
export const MULTI_DELETE_COLOR = 'MULTI_DELETE_COLOR';
export const GET_ONE_COLOR = 'GET_ONE_COLOR';

// SALES_REPRESENTATIVE
export const ADD_SALES_REPRESENTATIVE = 'ADD_SALES_REPRESENTATIVE';
export const UPDATE_SALES_REPRESENTATIVE = 'UPDATE_SALES_REPRESENTATIVE';
export const GET_SALES_REPRESENTATIVE = 'GET_SALES_REPRESENTATIVE';
export const DELETE_SALES_REPRESENTATIVE = 'DELETE_SALES_REPRESENTATIVE';
export const GET_ONE_SALES_REPRESENTATIVE = 'GET_ONE_SALES_REPRESENTATIVE';

// BILL_TERM
export const ADD_BILL_TERM = 'ADD_BILL_TERM';
export const UPDATE_BILL_TERM = 'UPDATE_BILL_TERM';
export const GET_BILL_TERM = 'GET_BILL_TERM';
export const DELETE_BILL_TERM = 'DELETE_BILL_TERM';
export const MULTI_DELETE_BILLTERM = 'MULTI_DELETE_BILLTERM';
export const GET_ONE_BILL_TERM = 'GET_ONE_BILL_TERM';

// BANK
export const ADD_BANK = 'ADD_BANK';
export const UPDATE_BANK = 'UPDATE_BANK';
export const GET_BANK = 'GET_BANK';
export const GET_All_BANK = 'GET_All_BANK';
export const DELETE_BANK = 'DELETE_BANK';
export const MULTI_DELETE_BANK = 'MULTI_DELETE_BANK';
export const GET_ONE_BANK = 'GET_ONE_BANK';

// DRIVER
export const ADD_DRIVER = 'ADD_DRIVER';
export const UPDATE_DRIVER = 'UPDATE_DRIVER';
export const GET_DRIVER = 'GET_DRIVER';
export const DELETE_DRIVER = 'DELETE_DRIVER';
export const GET_ONE_DRIVER = 'GET_ONE_DRIVER';

// GET_GROUP_IDS
export const GET_GROUP_IDS = 'GET_GROUP_IDS';

// ITEM_GROUP_ID
export const ADD_ITEM_GROUP_ID = 'ADD_ITEM_GROUP_ID';
export const UPDATE_ITEM_GROUP_ID = 'UPDATE_ITEM_GROUP_ID';
export const GET_ITEM_GROUP_ID = 'GET_ITEM_GROUP_ID';
export const DELETE_ITEM_GROUP_ID = 'DELETE_ITEM_GROUP_ID';
export const GET_ONE_ITEM_GROUP_ID = 'GET_ONE_ITEM_GROUP_ID';

// STYLE
export const ADD_STYLE = 'ADD_STYLE';
export const UPDATE_STYLE = 'UPDATE_STYLE';
export const GET_STYLE = 'GET_STYLE';
export const DELETE_STYLE = 'DELETE_STYLE';
export const GET_ONE_STYLE = 'GET_ONE_STYLE';

// SIZE
export const ADD_SIZE = 'ADD_SIZE';
export const UPDATE_SIZE = 'UPDATE_SIZE';
export const GET_SIZE = 'GET_SIZE';
export const DELETE_SIZE = 'DELETE_SIZE';
export const MULTI_DELETE_SIZE = 'MULTI_DELETE_SIZE';
export const GET_ONE_SIZE = 'GET_ONE_SIZE';

// HSN
export const ADD_HSN = 'ADD_HSN';
export const UPDATE_HSN = 'UPDATE_HSN';
export const GET_HSN = 'GET_HSN';
export const DELETE_HSN = 'DELETE_HSN';
export const GET_ONE_HSN = 'GET_ONE_HSN';

// MAIN_AND_SUB_HSN
export const ADD_MAIN_AND_SUB_HSN = 'ADD_MAIN_AND_SUB_HSN';
export const UPDATE_MAIN_AND_SUB_HSN = 'UPDATE_MAIN_AND_SUB_HSN';
export const GET_MAIN_AND_SUB_HSN = 'GET_MAIN_AND_SUB_HSN';
export const DELETE_MAIN_AND_SUB_HSN = 'DELETE_MAIN_AND_SUB_HSN';

//TAX GROUP
export const GET_TAX_GROUP = 'GET_TAX_GROUP';

// PATTERN
export const ADD_PATTERN = 'ADD_PATTERN';
export const UPDATE_PATTERN = 'UPDATE_PATTERN';
export const GET_PATTERN = 'GET_PATTERN';
export const DELETE_PATTERN = 'DELETE_PATTERN';

// COUNT_BY
export const ADD_COUNT_BY = 'ADD_COUNT_BY';
export const UPDATE_COUNT_BY = 'UPDATE_COUNT_BY';
export const GET_COUNT_BY = 'GET_COUNT_BY';
export const DELETE_COUNT_BY = 'DELETE_COUNT_BY';

// DISPATCH_BY
export const ADD_DISPATCH_BY = 'ADD_DISPATCH_BY';
export const UPDATE_DISPATCH_BY = 'UPDATE_DISPATCH_BY';
export const GET_DISPATCH_BY = 'GET_DISPATCH_BY';
export const DELETE_DISPATCH_BY = 'DELETE_DISPATCH_BY';

// HSN_SUB
export const ADD_HSN_SUB = 'ADD_HSN_SUB';
export const UPDATE_HSN_SUB = 'UPDATE_HSN_SUB';
export const GET_HSN_SUB = 'GET_HSN_SUB';
export const DELETE_HSN_SUB = 'DELETE_HSN_SUB';

// VEHICLE
export const ADD_VEHICLE = 'ADD_VEHICLE';
export const UPDATE_VEHICLE = 'UPDATE_VEHICLE';
export const GET_VEHICLE = 'GET_VEHICLE';
export const DELETE_VEHICLE = 'DELETE_VEHICLE';
export const MULTI_DELETE_VEHICLE = 'MULTI_DELETE_VEHICLE';
export const GET_ONE_VEHICLE = 'GET_ONE_VEHICLE';

// TRANSPORT
export const ADD_TRANSPORT = 'ADD_TRANSPORT';
export const UPDATE_TRANSPORT = 'UPDATE_TRANSPORT';
export const GET_TRANSPORT = 'GET_TRANSPORT';
export const DELETE_TRANSPORT = 'DELETE_TRANSPORT';
export const MULTI_DELETE_TRANSPORT = 'MULTI_DELETE_TRANSPORT';
export const GET_ONE_TRANSPORT = 'GET_ONE_TRANSPORT';

// DAYBOOK
export const ADD_DAYBOOK = 'ADD_DAYBOOK';
export const UPDATE_DAYBOOK = 'UPDATE_DAYBOOK';
export const GET_DAYBOOK = 'GET_DAYBOOK';
export const GET_DAYBOOKS = 'GET_DAYBOOKS';
export const GET_DAYBOOKS_FOR_MASTER = 'GET_DAYBOOKS_FOR_MASTER';
export const GET_ALL_DAYBOOKS = 'GET_ALL_DAYBOOKS';
export const GET_DAYBOOKS_FOR_PAYMENTS = 'GET_DAYBOOKS_FOR_PAYMENTS';
export const DELETE_DAYBOOK = 'DELETE_DAYBOOK';
export const MULTI_DELETE_DAYBOOK = 'MULTI_DELETE_DAYBOOK';
export const GET_ISSUE_DAYBOOK = 'GET_ISSUE_DAYBOOK';
export const GET_ONE_DAYBOOK = 'GET_ONE_DAYBOOK';
export const GET_PAYMENT_DAYBOOK = 'GET_PAYMENT_DAYBOOK';

//USER
// export const GET_USER = 'GET_USER';
// export const ADD_USER = 'ADD_USER';
// export const GET_USER_BY_ID = 'GET_USER_BY_ID';
// export const UPDATE_USER_RIGHTS = 'UPDATE_USER_RIGHTS';
// export const UPDATE_USER = 'UPDATE_USER';
export const DELETE_USER = 'DELETE_USER';
export const SEND_OTP = 'SEND_OTP';
export const RESET_PASSWORD = 'RESET_PASSWORD';

// UNIT
export const ADD_UNIT = 'ADD_UNIT';
export const UPDATE_UNIT = 'UPDATE_UNIT';
export const GET_UNIT = 'GET_UNIT';
export const GET_UNITS = 'GET_UNITS';
export const DELETE_UNIT = 'DELETE_UNIT';
export const GET_ONE_UNIT = 'GET_ONE_UNIT';

// VOUCHER
export const ADD_VOUCHER = 'ADD_VOUCHER';
export const UPDATE_VOUCHER = 'UPDATE_VOUCHER';
export const GET_VOUCHER = 'GET_VOUCHER';
export const GET_BANK_VOUCHER = 'GET_BANK_VOUCHER';
export const GET_ADJUSTED_VOUCHER = 'GET_ADJUSTED_VOUCHER';
export const GET_VOUCHERS = 'GET_VOUCHERS';
export const DELETE_VOUCHER = 'DELETE_VOUCHER';
export const MULTI_DELETE_VOUCHER = 'MULTI_DELETE_VOUCHER';
export const VOUCHER_PREV_NEXT = 'VOUCHER_PREV_NEXT';
export const GET_ONE_VOUCHER = 'GET_ONE_VOUCHER';
export const LAST_VOUCHER_DETAILS = 'LAST_VOUCHER_DETAILS';
export const GET_LAST_VOUCHER_DAYBOOK = 'GET_LAST_VOUCHER_DAYBOOK';
export const PENDING_VOUCHER_DETAILS = 'PENDING_VOUCHER_DETAILS';
export const ADJUSTMENT_VOUCHER_DETAILS = 'ADJUSTMENT_VOUCHER_DETAILS';
export const ADJUSTMENT_VOUCHER_BALANCE = 'ADJUSTMENT_VOUCHER_BALANCE';
export const ADD_OUT_ADJUSTMENT = 'ADD_OUT_ADJUSTMENT';
export const SET_PENDING_VOUCHER = 'SET_PENDING_VOUCHER';
export const UPDATE_VOUCHER_CLEARING_DATE = 'UPDATE_VOUCHER_CLEARING_DATE';
export const GET_OUT_ADJUSTMENTS = 'GET_OUT_ADJUSTMENTS';
export const ADD_OUT_ADJUSTMENTS = 'ADD_OUT_ADJUSTMENTS';
export const CLEAR_VOUCHER_DETAILS = 'CLEAR_VOUCHER_DETAILS';
export const CLEAR_LAST_VOUCHER_DETAILS = 'CLEAR_LAST_VOUCHER_DETAILS';

// GL Group
export const ADD_GL_GROUP = 'ADD_GL_GROUP';
export const UPDATE_GL_GROUP = 'UPDATE_GL_GROUP';
export const GET_GL_GROUP = 'GET_GL_GROUP';
export const GET_GL_GROUPS = 'GET_GL_GROUPS';
export const GET_GL_GROUPS_ALL = 'GET_GL_GROUPS_ALL';
export const DELETE_GL_GROUP = 'DELETE_GL_GROUP';
export const GET_ONE_GL_GROUP = 'GET_ONE_GL_GROUP';

// SALE_INVOICE
export const ADD_SALE_INVOICE = 'ADD_SALE_INVOICE';
export const GET_SALE_INVOICES = 'GET_SALE_INVOICES';
export const GET_SALE_INVOICE = 'GET_SALE_INVOICE';
export const GET_SALE_INVOICES_FOR_DAYBOOK = 'GET_SALE_INVOICES_FOR_DAYBOOK';
export const GET_SALE_INVOICES_TRANSACTIONS = 'GET_SALE_INVOICES_TRANSACTIONS';
export const UPDATE_SALE_INVOICE = 'UPDATE_SALE_INVOICE';
export const DELETE_SALE_INVOICE = 'DELETE_SALE_INVOICE';
export const DELETE_ADJUSTED_DOCS = 'DELETE_ADJUSTED_DOCS';
export const LAST_BILL_SALE_INVOICE = 'LAST_BILL_SALE_INVOICE';
export const GET_LAST_SALE_DAYBOOK = 'GET_LAST_SALE_DAYBOOK';
export const GET_ONE_SALE_INVOICE = 'GET_ONE_SALE_INVOICE';
export const EMPTY_ONE_SALE_INVOICE = 'EMPTY_ONE_SALE_INVOICE';
export const GET_SALE_INVOICE_WITH_PREV_AND_NEXT = 'GET_SALE_INVOICE_WITH_PREV_AND_NEXT';
export const GET_SALE_INVOICE_PREV_AND_NEXT = 'GET_SALE_INVOICE_PREV_AND_NEXT';
export const GET_ADJUSTED_DOCS = 'GET_ADJUSTED_DOCS';
export const GET_PENDING_VOUCHER_SALES_ADJUSTMENT = 'GET_PENDING_VOUCHER_SALES_ADJUSTMENT';
export const GET_PENDING_SALES_ADJUSTMENT = 'GET_PENDING_SALES_ADJUSTMENT';
export const GET_PURCHASE_ADJUSTMENT = 'GET_PURCHASE_ADJUSTMENT';
export const GET_PENDING_VOUCHER_WITH_PURCHASE_ADJUSTMENT = 'GET_PENDING_VOUCHER_WITH_PURCHASE_ADJUSTMENT';
export const UPDATE_SALES_DOC = 'UPDATE_SALES_DOC';
export const DELETE_SALES_DOC = 'DELETE_SALES_DOC';
export const DELETE_MULTI_SALES_INVOICE = 'DELETE_MULTI_SALES_INVOICE';
export const PARTY_SERVICE_BLOCK = 'PARTY_SERVICE_BLOCK';
export const GET_STORE_SALES = 'GET_STORE_SALES';

// SALES CHALLAN
export const GET_SALE_CHALLAN = 'GET_SALE_CHALLAN';
export const ADD_SALE_CHALLAN = 'ADD_SALE_CHALLAN';
export const UPDATE_SALE_CHALLAN = 'UPDATE_SALE_CHALLAN';
export const GET_SALE_CHALLAN_BY_ID = 'GET_SALE_CHALLAN_BY_ID';
export const DELETE_SALE_CHALLAN = 'DELETE_SALE_CHALLAN';
export const GET_LAST_SALE_CHALLAN_DAYBOOK = 'GET_LAST_SALE_CHALLAN_DAYBOOK';
export const DELETE_MULTI_SALES_CHALLAN = 'DELETE_MULTI_SALES_CHALLAN';

// SALE LINE ITEM
export const ADD_SALE_LINE_ITEM = 'ADD_SALE_LINE_ITEM';
export const UPDATE_SALE_LINE_ITEM = 'UPDATE_SALE_LINE_ITEM';
export const GET_SALE_LINE_ITEM = 'GET_SALE_LINE_ITEM';
export const GET_SALE_LINE_ITEMS = 'GET_SALE_LINE_ITEMS';
export const DELETE_SALE_LINE_ITEM = 'DELETE_SALE_LINE_ITEM';

// SALE RETURN
export const ADD_SALE_RETURN_INVOICE = 'ADD_SALE_RETURN_INVOICE';
export const GET_SALE_RETURN_INVOICES = 'GET_SALE_RETURNS_INVOICES';
export const GET_SALE_RETURN_INVOICES_FOR_DAYBOOK = 'GET_SALE_RETURN_INVOICES_FOR_DAYBOOK';
export const GET_SALE_RETURN_INVOICE = 'GET_SALE_RETURN_INVOICE';
export const GET_SALE_RETURN_INVOICES_TRANSACTIONS = 'GET_SALE_RETURN_INVOICES_TRANSACTIONS';
export const UPDATE_SALE_RETURN_INVOICE = 'UPDATE_SALE_RETURN_INVOICE';
export const DELETE_SALE_RETURN_INVOICE = 'DELETE_SALE_RETURN_INVOICE';
export const LAST_BILL_SALE_RETURN_INVOICE = 'LAST_BILL_SALE_RETURN_INVOICE';
export const GET_LAST_SALE_RETURN_DAYBOOK = 'GET_LAST_SALE_RETURN_DAYBOOK';
export const GET_ONE_SALE_RETURN = 'GET_ONE_SALE_RETURN';
export const EMPTY_ONE_SALE_RETURN = 'EMPTY_ONE_SALE_RETURN';
export const GET_SALE_RETURN_INVOICE_WITH_PREV_AND_NEXT = 'GET_SALE_RETURN_INVOICE_WITH_PREV_AND_NEXT';
export const GET_SALE_RETURN_INVOICE_PREV_AND_NEXT = 'GET_SALE_RETURN_INVOICE_PREV_AND_NEXT';
export const DELETE_MULTI_SALES_RETURN_INVOICE = 'DELETE_MULTI_SALES_RETURN_INVOICE';
export const GET_SALES_STOCKS = 'GET_SALES_STOCKS';

export const ADD_SALE_RETURN_LINE_ITEM = 'ADD_SALE_RETURN_LINE_ITEM';
export const UPDATE_SALE_RETURN_LINE_ITEM = 'UPDATE_SALE_RETURN_LINE_ITEM';
export const GET_SALE_RETURN_LINE_ITEM = 'GET_SALE_RETURN_LINE_ITEM';
export const GET_SALE_RETURN_LINE_ITEMS = 'GET_SALE_RETURN_LINE_ITEMS';
export const DELETE_SALE_RETURN_LINE_ITEM = 'DELETE_SALE_RETURN_LINE_ITEM';

// PURCHASE RETURNs
export const ADD_PURCHASE_RETURN_INVOICE = 'ADD_PURCHASE_RETURN_INVOICE';
export const GET_PURCHASE_RETURN_INVOICES = 'GET_PURCHASE_RETURNS_INVOICES';
export const GET_PURCHASE_RETURN_INVOICES_TRANSACTIONS = 'GET_PURCHASE_RETURN_INVOICES_TRANSACTIONS';
export const GET_PURCHASE_RETURN_INVOICES_FOR_DAYBOOK = 'GET_PURCHASE_RETURN_INVOICES_FOR_DAYBOOK';
export const GET_PURCHASE_RETURN_INVOICE = 'GET_PURCHASE_RETURN_INVOICE';
export const UPDATE_PURCHASE_RETURN_INVOICE = 'UPDATE_PURCHASE_RETURN_INVOICE';
export const DELETE_PURCHASE_RETURN_INVOICE = 'DELETE_PURCHASE_RETURN_INVOICE';
export const LAST_BILL_PURCHASE_RETURN_INVOICE = 'LAST_BILL_PURCHASE_RETURN_INVOICE';
export const GET_LAST_PURCHASE_RETURN_DAYBOOK = 'GET_LAST_PURCHASE_RETURN_DAYBOOK';
export const GET_ONE_PURCHASE_RETURN = 'GET_ONE_PURCHASE_RETURN';
export const EMPTY_ONE_PURCHASE_RETURN = 'EMPTY_ONE_PURCHASE_RETURN';
export const ADD_PURCHASE_RETURN_LINE_ITEM = 'ADD_PURCHASE_RETURN_LINE_ITEM';
export const UPDATE_PURCHASE_RETURN_LINE_ITEM = 'UPDATE_PURCHASE_RETURN_LINE_ITEM';
export const GET_PURCHASE_RETURN_LINE_ITEM = 'GET_PURCHASE_RETURN_LINE_ITEM';
export const GET_PURCHASE_RETURN_LINE_ITEMS = 'GET_PURCHASE_RETURN_LINE_ITEMS';
export const DELETE_PURCHASE_RETURN_LINE_ITEM = 'DELETE_PURCHASE_RETURN_LINE_ITEM';
export const GET_PURCHASE_RETURN_INVOICE_WITH_PREV_AND_NEXT = 'GET_PURCHASE_RETURN_INVOICE_WITH_PREV_AND_NEXT';
export const GET_PURCHASE_RETURN_INVOICE_PREV_AND_NEXT = 'GET_PURCHASE_RETURN_INVOICE_PREV_AND_NEXT';
export const DELETE_MULTI_PURCHASE_RETURN_INVOICE = 'DELETE_MULTI_PURCHASE_RETURN_INVOICE';

// PURCHASE_INVOICE
export const ADD_PURCHASE_INVOICE = 'ADD_PURCHASE_INVOICE';
export const GET_PURCHASE_INVOICES = 'GET_PURCHASE_INVOICES';
export const GET_PURCHASE_INVOICES_FOR_DAYBOOK = 'GET_PURCHASE_INVOICES_FOR_DAYBOOK';
export const UPDATE_PURCHASE_DOC = 'UPDATE_PURCHASE_DOC';
export const DELETE_PURCHASE_DOC = 'DELETE_PURCHASE_DOC';
export const GET_PURCHASE_INVOICES_TRANSACTIONS = 'GET_PURCHASE_INVOICES_TRANSACTIONS';
export const GET_PURCHASE_INVOICE = 'GET_PURCHASE_INVOICE';
export const UPDATE_PURCHASE_INVOICE = 'UPDATE_PURCHASE_INVOICE';
export const UPDATE_SYNC_PURCHASE_INVOICE = 'UPDATE_SYNC_PURCHASE_INVOICE';
export const DELETE_PURCHASE_INVOICE = 'DELETE_PURCHASE_INVOICE';
export const DELETE_MULTI_PURCHASE_INVOICE = 'DELETE_MULTI_PURCHASE_INVOICE';
export const LAST_BILL_PURCHASE_INVOICE = 'LAST_BILL_PURCHASE_INVOICE';
export const GET_LAST_PURCHASE_DAYBOOK = 'GET_LAST_PURCHASE_DAYBOOK';
export const ADD_PURCHASE_LINE_ITEM = 'ADD_PURCHASE_LINE_ITEM';
export const UPDATE_PURCHASE_LINE_ITEM = 'UPDATE_PURCHASE_LINE_ITEM';
export const GET_PURCHASE_LINE_ITEM = 'GET_PURCHASE_LINE_ITEM';
export const GET_PURCHASE_LINE_ITEMS = 'GET_PURCHASE_LINE_ITEMS';
export const DELETE_PURCHASE_LINE_ITEM = 'DELETE_PURCHASE_LINE_ITEM';
export const GET_ONE_PURCHASE_INVOICE = 'GET_ONE_PURCHASE_INVOICE';
export const EMPTY_ONE_PURCHASE_INVOICE = 'EMPTY_ONE_PURCHASE_INVOICE';
export const GET_PURCHASE_INVOICE_WITH_PREV_AND_NEXT = 'GET_SALE_INVOICE_WITH_PREV_AND_NEXT';
export const GET_PURCHASE_INVOICE_PREV_AND_NEXT = 'GET_PURCHASE_INVOICE_PREV_AND_NEXT';
export const SET_LOADING = 'SET_LOADING';
export const GET_PENDING_VOUCHER_PURCHASE_ADJUSTMENT = 'GET_PENDING_VOUCHER_PURCHASE_ADJUSTMENT';
export const GRAY_PURCHASE_PENDING_ISSUE = 'GRAY_PURCHASE_PENDING_ISSUE';
export const GET_PURCHASE_DOC_PDF = 'GET_PURCHASE_DOC_PDF';

// SIZE
export const ADD_UQC = 'ADD_UQC';
export const UPDATE_UQC = 'UPDATE_UQC';
export const GET_ALL_UQC = 'GET_ALL_UQC';
export const GET_ALL_UQC_DATA = 'GET_ALL_UQC_DATA';
export const GET_UQC = 'GET_UQC';
export const DELETE_UQC = 'DELETE_UQC';

// SALES LINE DETAILS
export const ADD_SALES_LINE_DETAILS = 'ADD_SALES_LINE_DETAILS';
export const UPDATE_SALES_LINE_DETAILS = 'UPDATE_SALES_LINE_DETAILS';
export const GET_SALES_LINE_DETAILS = 'GET_SALES_LINE_DETAILS';
export const GET_SALES_LINE_DETAIL = 'GET_SALES_LINE_DETAIL';
export const DELETE_SALES_LINE_DETAILS = 'DELETE_SALES_LINE_DETAILS';
export const GET_STOCK = 'GET_STOCK';
export const GET_SERIAL_TO_WAREHOUS = 'GET_SERIAL_TO_WAREHOUS';
export const GET_SERIAL_WISE_HISTORY = 'GET_SERIAL_WISE_HISTORY';

export const ADD_SALES_RETURN_LINE_DETAILS = 'ADD_SALES_RETURN_LINE_DETAILS';
export const UPDATE_SALES_RETURN_LINE_DETAILS = 'UPDATE_SALES_RETURN_LINE_DETAILS';
export const GET_SALES_RETURN_LINE_DETAILS = 'GET_SALES_RETURN_LINE_DETAILS';
export const GET_SALES_RETURN_LINE_DETAIL = 'GET_SALES_RETURN_LINE_DETAIL';
export const DELETE_SALES_RETURN_LINE_DETAILS = 'DELETE_SALES_RETURN_LINE_DETAILS';

// PURCHASE LINE DETAILS
export const ADD_PURCHASE_LINE_DETAILS = 'ADD_PURCHASE_LINE_DETAILS';
export const UPDATE_PURCHASE_LINE_DETAILS = 'UPDATE_PURCHASE_LINE_DETAILS';
export const GET_PURCHASE_LINE_DETAILS = 'GET_PURCHASE_LINE_DETAILS';
export const GET_PURCHASE_LINE_DETAIL = 'GET_PURCHASE_LINE_DETAIL';
export const DELETE_PURCHASE_LINE_DETAILS = 'DELETE_PURCHASE_LINE_DETAILS';

export const ADD_PURCHASE_RETURN_LINE_DETAILS = 'ADD_PURCHASE_RETURN_LINE_DETAILS';
export const UPDATE_PURCHASE_RETURN_LINE_DETAILS = 'UPDATE_PURCHASE_RETURN_LINE_DETAILS';
export const GET_PURCHASE_RETURN_LINE_DETAILS = 'GET_PURCHASE_RETURN_LINE_DETAILS';
export const GET_PURCHASE_RETURN_LINE_DETAIL = 'GET_PURCHASE_RETURN_LINE_DETAIL';
export const DELETE_PURCHASE_RETURN_LINE_DETAILS = 'DELETE_PURCHASE_RETURN_LINE_DETAILS';

// REPORTS
export const REPORT_SALES_DETAIL = 'REPORT_SALES_DETAIL';
export const REPORT_PURCHASE_DETAIL = 'REPORT_PURCHASE_DETAIL';
export const REPORT_SALE_SUMMARY = 'REPORT_SALE_SUMMARY';
export const REPORT_PURCHASE_SUMMARY = 'REPORT_PURCHASE_SUMMARY';
export const REPORT_OUTSTANDING_DETAIL = 'REPORT_OUTSTANDING_DETAIL';
export const REPORT_ITEM_BY_CONTACT = 'REPORT_ITEM_BY_CONTACT';
export const REPORT_INVENTORY_DETAIL = 'REPORT_INVENTORY_DETAIL';
export const REPORT_STOCK_DETAIL = 'REPORT_STOCK_DETAIL';
export const REPORT_SERIALWISE_HISTORY = 'REPORT_SERIALWISE_HISTORY';
export const REPORT_TDS = 'REPORT_TDS';
export const REPORT_LEDGER = 'REPORT_LEDGER';
export const REPORT_BILL_TO_BILL = 'REPORT_BILL_TO_BILL';
export const CLEAR_CACHE_REPORT = 'CLEAR_CACHE_REPORT';
export const REPORT_TRIAL_BALANCE = 'REPORT_TRIAL_BALANCE';
export const REPORT_TRIAL_BALANCE_GLGROUP_WISE = 'REPORT_TRIAL_BALANCE_GLGROUP_WISE';
export const REPORT_TRIAL_BALANCE_FULL = 'REPORT_TRIAL_BALANCE_FULL';
export const REPORT_BALANCE_SHEET = 'REPORT_BALANCE_SHEET';
export const REPORT_BALANCE_SHEET_SUMMARY = 'REPORT_BALANCE_SHEET_SUMMARY';
export const REPORT_BALANCE_SHEET_VERTICAL = 'REPORT_BALANCE_SHEET_VERTICAL';
export const REPORT_PROFIT_LOSS_MONTHLY = 'REPORT_PROFIT_LOSS_MONTHLY';
export const REPORT_STORE_STOCK = 'REPORT_STORE_STOCK';
export const REPORT_STORE_STOCK_FOR_RECEIVE = 'REPORT_STORE_STOCK_FOR_RECEIVE';
export const REPORT_B2B_SALES = 'REPORT_B2B_SALES';
export const REPORT_B2CL_SALES = 'REPORT_B2CL_SALES';
export const REPORT_B2CS_SALES = 'REPORT_B2CS_SALES';
export const REPORT_CDNR_SALES = 'REPORT_CDNR_SALES';
export const REPORT_CDNUR_SALES = 'REPORT_CDNUR_SALES';
export const REPORT_EXP_SALES = 'REPORT_EXP_SALES';
export const REPORT_EXEMP_SALES = 'REPORT_EXEMP_SALES';
export const REPORT_HSNB2B_SALES = 'REPORT_HSNB2B_SALES';
export const REPORT_HSNB2C_SALES = 'REPORT_HSNB2C_SALES';
export const REPORT_DOC_SALES = 'REPORT_DOC_SALES';
export const REPORT_GSTR3B = 'REPORT_GSTR3B';
export const GSTR_2AB2B_RECONCILATION = 'GSTR_2AB2B_RECONCILATION';
export const REPORT_FORMAT = 'REPORT_FORMAT';
export const UPDATE_REPORT_FORMAT = 'UPDATE_REPORT_FORMAT';
export const ADD_REPORT_FORMAT = 'ADD_REPORT_FORMAT';
export const DELETE_REPORT_FORMAT = 'DELETE_REPORT_FORMAT';
export const REPORT_ALL_TRANSACTION = 'REPORT_ALL_TRANSACTION';
export const GSTR_EXCEL_GENERATE_START = 'GSTR_EXCEL_GENERATE_START';
export const GSTR_EXCEL_GENERATE_SUCCESS = 'GSTR_EXCEL_GENERATE_SUCCESS';
export const GSTR_EXCEL_GENERATE_ERROR = 'GSTR_EXCEL_GENERATE_ERROR';
export const GSTR_EXCEL_DOWNLOAD_START = 'GSTR_EXCEL_DOWNLOAD_START';
export const GSTR_EXCEL_DOWNLOAD_SUCCESS = 'GSTR_EXCEL_DOWNLOAD_SUCCESS';
export const GSTR_EXCEL_DOWNLOAD_ERROR = 'GSTR_EXCEL_DOWNLOAD_ERROR';

//USER
export const GET_USER = 'GET_USER';
export const ADD_USER = 'ADD_USER';
export const GET_USER_BY_ID = 'GET_USER_BY_ID';
export const UPDATE_USER_RIGHTS = 'UPDATE_USER_RIGHTS';
export const UPDATE_USER = 'UPDATE_USER';
export const USER_PROFILE = 'USER_PROFILE';
export const UPDATE_USER_HISTORY = 'UPDATE_USER_HISTORY';
export const IS_ERROR = 'IS_ERROR';
export const GET_USERS = 'GET_USERS';
export const UPDATE_USER_STATUS = 'UPDATE_USER_STATUS';
export const SEND_OTP_IN_EMAIL_OR_MOBILE = 'SEND_OTP_IN_EMAIL_OR_MOBILE';
// export const DELETE_USER = 'DELETE_USER';

//GLOBAL SETTINGS
export const USER_GLOBAL_SETTINGS = 'USER_GLOBAL_SETTINGS';
export const UPDATE_GLOBAL_SETTING = 'UPDATE_GLOBAL_SETTING';
export const GET_WP_SETTING = 'GET_WP_SETTING';

// AREA
export const ADD_AREA = 'ADD_AREA';
export const GET_AREA = 'GET_AREA';
export const GET_AREA_BY_ID = 'GET_AREA_BY_ID';
export const UPDATE_AREA = 'UPDATE_AREA';
export const DELETE_AREA = 'DELETE_AREA';

// Action Types
export const GET_ALL_GLBOAL_IMEI = 'GET_ALL_GLOBAL_IMEI';
export const ADD_GLBOAL_IMEI = 'ADD_GLBOAL_IMEI';
export const UPDATE_GLBOAL_IMEI = 'UPDATE_GLBOAL_IMEI';
export const DELETE_GLBOAL_IMEI = 'DELETE_GLBOAL_IMEI';
export const CHECK_GLOBAL_IMEI = 'CHECK_GLBOAL_IMEI';
export const GET_GLOBAL_IMEI_WITH_STOCK = 'GET_GLOBAL_IMEI_WITH_STOCK';
export const RESET_USER_PASSWORD = 'RESET_USER_PASSWORD';

// Action Types
export const GET_ALL_DASHBOARD_WHATS_NEW = 'GET_ALL_DASHBOARD_WHATS_NEW';
export const GET_ROJMEL = 'GET_ROJMEL';
export const GET_TOTAL_SALES_AND_PURCHASES = 'GET_TOTAL_SALES_AND_PURCHASES';
export const GET_TOP_FIVE_PARTY_WISE_PURCHASE = 'GET_TOP_FIVE_PARTY_WISE_PURCHASE';
export const GET_TOP_FIVE_PARTY_WISE_SALES = 'GET_TOP_FIVE_PARTY_WISE_SALES';
export const GET_MONTHLY_SALES_SUMMARY = 'GET_MONTHLY_SALES_SUMMARY';
export const GET_MONTHLY_PURCHASE_SUMMARY = 'GET_MONTHLY_PURCHASE_SUMMARY';
export const GET_QUARTERLY_SALES_SUMMARY = 'GET_QUARTERLY_SALES_SUMMARY';
export const GET_QUARTERLY_PURCHASE_SUMMARY = 'GET_QUARTERLY_PURCHASE_SUMMARY';
export const GET_GROWTH_RATE = 'GET_GROWTH_RATE';
export const GET_DAY_OF_WEEK_PERFORMANCE = 'GET_DAY_OF_WEEK_PERFORMANCE';
export const GET_TOP_TO_BOTTOM_PERFORMANCE = 'GET_TOP_TO_BOTTOM_PERFORMANCE';
export const GET_MOVING_AVERAGE_TRENDS = 'GET_MOVING_AVERAGE_TRENDS';
export const GET_PROFITABILITY_ANALYSIS_BY_CUSTOMER = 'GET_PROFITABILITY_ANALYSIS_BY_CUSTOMER';
export const GET_CASH_FLOW_ANALYSIS = 'GET_CASH_FLOW_ANALYSIS';
export const GET_TRANSACTION_SIZE_DISTRIBUTION_ANALYSIS = 'GET_TRANSACTION_SIZE_DISTRIBUTION_ANALYSIS';
export const GET_AGING_ANALYSIS = 'GET_AGING_ANALYSIS';
export const GET_HEATMAP_DATA = 'GET_HEATMAP_DATA';
export const GET_YEAR_OVER_YEAR_COMPARISON = 'GET_YEAR_OVER_YEAR_COMPARISON';
export const GET_CUSTOMER_CONCENTRATION_ANALYSIS = 'GET_CUSTOMER_CONCENTRATION_ANALYSIS';
export const GET_WEEKLY_PERFORMANCE_TRENDS = 'GET_WEEKLY_PERFORMANCE_TRENDS';
export const GET_CITY_WISE_SALES = 'GET_CITY_WISE_SALES';
export const GET_EXCEPTION_REPORTING = 'GET_EXCEPTION_REPORTING';
export const GET_MONTHLY_CUSTOMER_SALES = 'GET_MONTHLY_CUSTOMER_SALES';
export const GET_CUSTOMER_SALES_VALUE = 'GET_CUSTOMER_SALES_VALUE';
export const GET_FINANCIAL_YEARS = 'GET_FINANCIAL_YEARS';
export const GET_CASH_AND_BANK_BALANCE = 'GET_CASH_AND_BANK_BALANCE';
export const GET_RECEIVE_AND_PAY = 'GET_RECEIVE_AND_PAY';
export const GET_SALES_PAYMENT_RECEIVE_REPORT = 'GET_SALES_PAYMENT_RECEIVE_REPORT';
export const GET_PURCHASE_PAID_REPORT = 'GET_PURCHASE_PAID_REPORT';
export const GET_LAST_FIVE_YEAR_SALES_COMPARISON_REPORT = 'GET_LAST_FIVE_YEAR_SALES_COMPARISON_REPORT';
export const GET_LAST_FIVE_YEAR_PURCHASE_COMPARISON_REPORT = 'GET_LAST_FIVE_YEAR_PURCHASE_COMPARISON_REPORT';
export const DELETE_OVER_ADJUSTED = 'DELETE_OVER_ADJUSTED';
export const DELETE_EXTRA_OVER_ADJUSTED = 'DELETE_EXTRA_OVER_ADJUSTED';
export const DELETE_EXTRA_LEDGER_ENTRIES = 'DELETE_EXTRA_LEDGER_ENTRIES';
export const SALES_PURCHASES_OVERVIEW = 'SALES_PURCHASES_OVERVIEW';
export const GET_BARCODE_DATA = 'GET_BARCODE_DATA';
export const SAVE_BARCODE_DATA = 'SAVE_BARCODE_DATA';
export const UPDATE_BULK_STATUS = 'UPDATE_BULK_STATUS';
export const GET_BALANCE = 'GET_BALANCE';

// feedback
export const ADD_FEEDBACK = 'ADD_FEEDBACK';
// export const GET_FEEDBACK = 'GET_FEEDBACK';

// ISSUE INVOICE
export const ADD_ISSUE_INVENTORY = 'ADD_ISSUE_INVENTORY';
export const ADD_MANY_ISSUE_INVENTORY = 'ADD_MANY_ISSUE_INVENTORY';
export const GET_ISSUES_INVENTORY = 'GET_ISSUES_INVENTORY';
export const GET_ISSUE_INVENTORY = 'GET_ISSUE_INVENTORY';
export const UPDATE_ISSUE_INVENTORY = 'UPDATE_ISSUE_INVENTORY';
export const DELETE_ISSUE_INVENTORY = 'DELETE_ISSUE_INVENTORY';
export const EMPTY_ONE_ISSUE_INVENTORY = 'EMPTY_ONE_ISSUE_INVENTORY';
export const GET_LAST_ISSUE_DAYBOOK = 'GET_LAST_ISSUE_DAYBOOK';
export const GET_ISSUE_INVENTORY_PREV_AND_NEXT = 'GET_ISSUE_INVENTORY_PREV_AND_NEXT';
export const GET_SINGLE_ISSUES_INVENTORY = 'GET_SINGLE_ISSUES_INVENTORY';
export const DELETE_MULTI_ISSUE = 'DELETE_MULTI_ISSUE';
export const UPDATE_ISSUE_DOC = 'UPDATE_ISSUE_DOC';
export const DELETE_ISSUE_DOC = 'DELETE_ISSUE_DOC';

export const ADD_ISSUE = 'ADD_ISSUE';
export const GET_ISSUES = 'GET_ISSUES';
export const GET_ISSUE = 'GET_ISSUE';
export const UPDATE_ISSUE = 'UPDATE_ISSUE';
export const DELETE_ISSUE = 'DELETE_ISSUE_';
export const CLEAR_ISSUE = 'CLEAR_ISSUE';
export const GET_ISSUE_DOCUMENT = 'GET_ISSUE_DOCUMENT';

export const ADD_ISSUE_LINE_ITEM = 'ADD_ISSUE_LINE_ITEM';
export const GET_ISSUES_LINE_ITEM = 'GET_ISSUES_LINE_ITEM';
export const GET_ISSUE_LINE_ITEM = 'GET_ISSUE_LINE_ITEM';
export const UPDATE_ISSUE_LINE_ITEM = 'UPDATE_ISSUE_LINE_ITEM';
export const DELETE_ISSUE_LINE_ITEM = 'DELETE_ISSUE_LINE_ITEM';
export const EMPTY_ONE_ISSUE_LINE_ITEM = 'EMPTY_ONE_ISSUE';

export const ADD_RECEIVE_INVENTORY = 'ADD_RECEIVE_INVENTORY';
export const GET_RECEIVE_INVENTORIES = 'GET_RECEIVE_INVENTORIES';
export const GET_RECEIVE_INVENTORIES_FOR_RO = 'GET_RECEIVE_INVENTORIES_FOR_RO';
export const GET_RECEIVE_INVENTORIES_FOR_ITV = 'GET_RECEIVE_INVENTORIES_FOR_ITV';
export const GET_RECEIVE_INVENTORIES_FOR_RFV = 'GET_RECEIVE_INVENTORIES_FOR_RFV';
export const GET_RECEIVE_INVENTORIES_FOR_S = 'GET_RECEIVE_INVENTORIES_FOR_S';
export const GET_RECEIVE_INVENTORIES_FOR_R = 'GET_RECEIVE_INVENTORIES_FOR_R';
export const GET_RECEIVE_INVENTORY = 'GET_RECEIVE_INVENTORY';
export const UPDATE_RECEIVE_INVENTORY = 'UPDATE_RECEIVE_INVENTORY';
export const DELETE_RECEIVE_INVENTORY = 'DELETE_RECEIVE_INVENTORY';
export const EMPTY_ONE_RECEIVE_INVENTORY = 'EMPTY_ONE_RECEIVE_INVENTORY';
export const GET_LAST_RECEIVE_DAYBOOK = 'GET_LAST_RECEIVE_DAYBOOK';
export const GET_RECEIVE_INVENTORY_PREV_AND_NEXT = 'GET_RECEIVE_INVENTORY_PREV_AND_NEXT';
export const GET_PENDING_RECEIVE_INVENTORY = 'GET_PENDING_RECEIVE_INVENTORY';
export const GET_SINGLE_RECEIVE_INVENTORIES = 'GET_SINGLE_RECEIVE_INVENTORIES';
export const DELETE_MULTI_RECEIVE = 'DELETE_MULTI_RECEIVE';
export const DELETE_RECEIVE_DOC = 'DELETE_RECEIVE_DOC';
export const UPDATE_RECEIVE_DOC = 'UPDATE_RECEIVE_DOC';

export const ADD_RECEIVE = 'ADD_RECEIVE';
export const GET_RECEIVES = 'GET_RECEIVES';
export const GET_RECEIVE = 'GET_RECEIVE';
export const UPDATE_RECEIVE = 'UPDATE_RECEIVE';
export const DELETE_RECEIVE = 'DELETE_RECEIVE';
export const EMPTY_ONE_RECEIVE = 'EMPTY_ONE_RECEIVE';

export const ADD_RECEIVE_LINE_ITEM = 'ADD_RECEIVE_LINE_ITEM';
export const GET_RECEIVES_LINE_ITEM = 'GET_RECEIVES_LINE_ITEM';
export const GET_RECEIVE_LINE_ITEM = 'GET_RECEIVE_LINE_ITEM';
export const UPDATE_RECEIVE_LINE_ITEM = 'UPDATE_RECEIVE_LINE_ITEM';
export const DELETE_RECEIVE_LINE_ITEM = 'DELETE_RECEIVE_LINE_ITEM';
export const EMPTY_ONE_RECEIVE_LINE_ITEM = 'EMPTY_ONE_RECEIVE';

// PrintFormat
export const ADD_PRINT_FORMATS = 'ADD_PRINT_FORMATS';
export const UPDATE_PRINT_FORMATS = 'UPDATE_PRINT_FORMATS';
export const GET_PRINT_FORMATS = 'GET_PRINT_FORMATS';
export const DELETE_PRINT_FORMATS = 'DELETE_PRINT_FORMATS';
export const GET_ONE_PRINT = 'GET_ONE_PRINT';
export const CLEAR_ONE_PRINT = 'CLEAR_ONE_PRINT';

// SetupFormat
export const ADD_SETUP_FORMATS = 'ADD_SETUP_FORMATS';
export const UPDATE_SETUP_FORMATS = 'UPDATE_SETUP_FORMATS';
export const GET_SETUP_FORMATS = 'GET_SETUP_FORMATS';
export const DELETE_SETUP_FORMATS = 'DELETE_SETUP_FORMATS';
export const GET_ONE_SETUP = 'GET_ONE_SETUP';
export const SETUP_FORMAT_CUSTOM_QUERY = 'SETUP_FORMAT_CUSTOM_QUERY';

// E WAY BILL AND E INVOICE
export const CANCEL_E_WAY_BILL = 'CANCEL_E_WAY_BILL';
export const GENERATE_E_WAY_BILL = 'GENERATE_E_WAY_BILL';
export const CANCEL_E_INVOICE = 'CANCEL_E_INVOICE';
export const GENERATE_E_INVOICE = 'GENERATE_E_INVOICE';
export const GET_EWAYBILL_AND_EINVOICE = 'GET_EWAYBILL_AND_EINVOICE';

// GLOBAL SEARCH
export const GET_GLOBAL_SEARCH = 'GET_GLOBAL_SEARCH';

// Utility
export const POST_MERGE_CODE = 'POST_MERGE_CODE';
export const POST_DELETE_UNUSED_MASTER = 'POST_DELETE_UNUSED_MASTER';
export const POST_COLUMNS_HIDE_SHOW = 'POST_COLUMNS_HIDE_SHOW';
export const BACKUP_DATABASE = 'BACKUP_DATABASE';
export const BACKUP_DATABASE_START = 'BACKUP_DATABASE_START';
export const BACKUP_DATABASE_SUCCESS = 'BACKUP_DATABASE_SUCCESS';
export const BACKUP_DATABASE_PROGRESS = 'BACKUP_DATABASE_PROGRESS';
export const BACKUP_DATABASE_ERROR = 'BACKUP_DATABASE_ERROR';
export const GENERATE_BULK_EWAY_EINVOICE = 'GENERATE_BULK_EWAY_EINVOICE';

// Stock Transfer
export const ADD_STOCK_TRANSFER = 'ADD_STOCK_TRANSFER';
export const UPDATE_STOCK_TRANSFER = 'UPDATE_STOCK_TRANSFER';
export const DELETE_STOCK_TRANSFER = 'DELETE_STOCK_TRANSFER';
export const GET_STOCK_TRANSFER = 'GET_STOCK_TRANSFER';
export const GET_STOCK_TRANSFER_BY_ID = 'GET_STOCK_TRANSFER_BY_ID';
export const GET_STOCK_TRANSFER_LAST_DOCNO = 'GET_STOCK_TRANSFER_LAST_DOCNO';

// Logs
export const GET_LOGS = 'GET_LOGS';
export const UPDATE_LOGS = 'UPDATE_LOGS';
export const GET_ONE_LOG = 'GET_ONE_LOG';

// CHECK_OS
export const GET_ACCOUNT_WITH_DUP_GSTIN = 'GET_ACCOUNT_WITH_DUP_GSTIN';
export const GET_EMPTY_SERIALNO_ENTRY = 'GET_EMPTY_SERIALNO_ENTRY';
export const GET_CGST_NOT_EQUAL_TO_SGST = 'GET_CGST_NOT_EQUAL_TO_SGST';
export const GET_DUP_ITEM = 'GET_DUP_ITEM';
export const GET_DUP_SERIALNO_IN_TRAN = 'GET_DUP_SERIALNO_IN_TRAN';
export const GET_EXTRA_LEDGER = 'GET_EXTRA_LEDGER';
export const GET_ISSUE_DATE_LESS_THEN_PORR_DATE = 'GET_ISSUE_DATE_LESS_THEN_PORR_DATE';
export const GET_WRONG_SERIAL_NO_DUE_TO_LOSS_OF_INCONN = 'GET_WRONG_SERIAL_NO_DUE_TO_LOSS_OF_INCONN';
export const GET_WITHOUT_LEDGER = 'GET_WITHOUT_LEDGER';
export const GET_TRAN_WITH_MISSING_TRANSPORT = 'GET_TRAN_WITH_MISSING_TRANSPORT';
export const GET_TRAN_WITH_MISSING_ITEM = 'GET_TRAN_WITH_MISSING_ITEM';
export const GET_TRAN_WITH_MISSING_ACCOUNT = 'GET_TRAN_WITH_MISSING_ACCOUNT';
export const GET_TRAN_WITH_SERIAL_NO_WITHOUT_ID = 'GET_TRAN_WITH_SERIAL_NO_WITHOUT_ID';
export const GET_SERIAL_NO_WITH_STOCK = 'GET_SERIAL_NO_WITH_STOCK';
export const GET_SERIAL_NO_WITH_NEGATIVE_STOCK = 'GET_SERIAL_NO_WITH_NEGATIVE_STOCK';
export const GET_SERIAL_NO_SOLD_WITHOUT_P = 'GET_SERIAL_NO_SOLD_WITHOUT_P';
export const GET_SAME_SERIAL_NO_WITH_DIFFERENET_ITEM = 'GET_SAME_SERIAL_NO_WITH_DIFFERENET_ITEM';
export const GET_SR_DATE_LESS_THAN_S_DATE = 'GET_SR_DATE_LESS_THAN_S_DATE';
export const GET_S_DATE_LESS_THAN_P_DATE = 'GET_S_DATE_LESS_THAN_P_DATE';
export const GET_PR_RATE_NOT_SAME_WITH_P_RATE = 'GET_PR_RATE_NOT_SAME_WITH_P_RATE';
export const GET_P_WITH_PARTY_DATE_PARTY_BILL_NO_DIFFERENCE = 'GET_P_WITH_PARTY_DATE_PARTY_BILL_NO_DIFFERENCE';
export const GET_PR_DATE_LESS_THEN_P_DATE = 'GET_PR_DATE_LESS_THEN_P_DATE';
export const GET_LD_WITH_OUT_CORRESPONDING_LI_OR_HEADER = 'GET_LD_WITH_OUT_CORRESPONDING_LI_OR_HEADER';
export const GET_OVER_ADJUSTMENT = 'GET_OVER_ADJUSTMENT';
export const GET_LI_ITEMID_NOT_EQUAL_LD_ITEMID = 'GET_LI_ITEMID_NOT_EQUAL_LD_ITEMID';
export const GET_BALANCE_DIFFERENCE_IN_LEDGER = 'GET_BALANCE_DIFFERENCE_IN_LEDGER';
export const GET_IN_COMPLETE_LEDGER_ENTRIES = 'GET_IN_COMPLETE_LEDGER_ENTRIES';
export const GET_DUPLICATE_LEDGER_FOR_SAME_ACCOUNT = 'GET_DUPLICATE_LEDGER_FOR_SAME_ACCOUNT';
export const GET_AUTO_ENHANCE = 'GET_AUTO_ENHANCE';

// Package
export const GET_PACKAGE = 'GET_PACKAGE';
export const VALIDATE_CUSTOMER = 'VALIDATE_CUSTOMER';
export const ADD_CUSTOMER_REGISTOR = 'ADD_CUSTOMER_REGISTOR';
export const GET_DASHBOARD_COUNT = 'GET_DASHBOARD_COUNT';
export const GET_SETTING_FOR_WEB = 'GET_SETTING_FOR_WEB';
export const ADD_ORDER = 'ADD_ORDER';
export const GET_GLOBAL_SETTING = 'GET_GLOBAL_SETTING';
export const GET_PACKAGE_CUSTOMER = 'GET_PACKAGE_CUSTOMER';
export const UPDATE_PACKAGE_CUSTOMER = 'UPDATE_PACKAGE_CUSTOMER';

// NotifyMe
export const GET_NOTIFY_ME = 'GET_NOTIFY_ME';
export const ADD_NOTIFY_ME = 'ADD_NOTIFY_ME';
export const UPDATE_NOTIFY_ME = 'UPDATE_NOTIFY_ME';
export const UPDATE_NOTIFY_ME_STATUS = 'UPDATE_NOTIFY_ME_STATUS';
export const DELETE_NOTIFY_ME = 'DELETE_NOTIFY_ME';
export const GET_NOTIFICATION = 'GET_NOTIFICATION';
export const READ_NOTIFICATION = 'READ_NOTIFICATION';

// Sales Challan
export const GET_PURCHASE_CHALLANS = 'GET_PURCHASE_CHALLANS';
export const ADD_PURCHASE_CHALLAN = 'ADD_PURCHASE_CHALLAN';
export const GET_PURCHASE_CHALLAN = 'GET_PURCHASE_CHALLAN';
export const UPDATE_PURCHASE_CHALLAN = 'UPDATE_PURCHASE_CHALLAN';
export const DELETE_PURCHASE_CHALLAN = 'DELETE_PURCHASE_CHALLAN';
export const GET_LAST_PURCHASE_CHALLAN_DAYBOOK = 'GET_LAST_PURCHASE_CHALLAN_DAYBOOK';
export const DELETE_MULTI_PURCHASE_CHALLAN_INVOICE = 'DELETE_MULTI_PURCHASE_CHALLAN_INVOICE';
export const EMPTY_ONE_PURCHASE_CHALLAN_INVOICE = 'EMPTY_ONE_PURCHASE_CHALLAN_INVOICE';
